import type { ResourceProps } from 'react-admin';
import PortraitIcon from '@mui/icons-material/Portrait';
import { type ComponentType, lazy } from 'react';

const AsyncPageList = lazy(() => import('./list'));
const AsyncPageShow = lazy(() => import('./show'));
const AsyncPageCreate = lazy(() => import('./create'));

export default {
  list: AsyncPageList as ComponentType<any>,
  show: AsyncPageShow as ComponentType<any>,
  create: AsyncPageCreate as ComponentType<any>,
  icon: PortraitIcon as ComponentType<any>,
} as ResourceProps;
